import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { CurrencyOutputDTO } from './currencyDTO'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
class CurrencyServices {
  async getByAll(): Promise<CurrencyOutputDTO[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/currency/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getByParams(params: object | null, paramsInURL: string | null = null): Promise<CurrencyOutputDTO[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/currency${paramsInURL ? paramsInURL : ''}`,
        {
          headers: { 'authentication-token': getJWT()! },
          params: params,
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deleteCurrencyByWorkUnit(currency: object): Promise<any> {
    try {
      const res = await axios.delete(`${process.env.REACT_APP_URL_RESERVATION}/currency-by-work-unit/`, {
        headers: { 'authentication-token': getJWT()! },
        data: currency,
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deleteCurrencyByBusinessUnit(currency: object): Promise<any> {
    try {
      const res = await axios.delete(`${process.env.REACT_APP_URL_RESERVATION}/currency-by-business-unit/`, {
        headers: { 'authentication-token': getJWT()! },
        data: currency,
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}
export const currencyServices = new CurrencyServices()
